import {
  Link,
  LinkProps,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";

interface AppLinkProps extends LinkProps {
  onClick?: () => void;
}

export default function AppLink({
  to,
  className,
  children,
  onClick,
}: AppLinkProps) {
  const [params] = useSearchParams();
  const lId = params.get("lId");

  const linkProps = {
    to:
      typeof to === "number" || !lId
        ? to
        : typeof to === "string"
        ? { pathname: to, search: `?${createSearchParams({ lId })}` }
        : !to.search
        ? { ...to, search: `?${createSearchParams({ lId })}` }
        : (() => {
            const params = new URLSearchParams(to.search);
            params.set("lId", lId);
            return { ...to, search: `?${params}` };
          })(),
    className,
    children,
    onClick, 
  };

  return <Link {...linkProps} />;
}
